import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
} from "@mui/material";

// import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
// import WheelTypeService from "src/service/wheel";
import AssignDriver_VehicleService from "src/service/assigndriverService";
import { useNavigate } from "react-router";
import swal from "sweetalert";
// import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
// import moment from "moment";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Vehicle Assign to Driver List ",
  },
];

const AssignVehicle2Driver = () => {
  // ====================================

  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [wheels, setWheels] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("driver_name"); // Initial column to sort

  const fetchWheelsData = async () => {
    try {
      const res = await AssignDriver_VehicleService.getAssignedDriver({});
      setWheels(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteAssignDriver = async (id) => {
    swal({
      title: "Delete Assign Driver",
      text: "Are you sure you want to delete assigned driver?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await AssignDriver_VehicleService.deleteassignDriver(
            {
              id: id,
              d_by: sessionData.data.id,
            }
          );
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetchWheelsData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchWheelsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredAssigendDriver = wheels.filter(
    (man) =>
      man.driver_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.vehicle_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
      man.vehicle_no.includes(searchTerm) ||
      man.assign_date_time.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = wheels.filter((man) =>
      man.driver_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [wheels, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = ["Sl. No", "Driver", "Vehicle Number", "Assign Date"];

    const data = visibleData.map((man, index) => [
      index + 1,
      man.driver_name,
      man.vehicle_no,
      man.assign_date_time,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "assignedDriver_data.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedAssignedDriver = filteredAssigendDriver.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer
      title=" Vehicle Assign to Driver List "
      description="this is Basic Table page"
    >
      {/* breadcrumb */}
      <Breadcrumb title=" Vehicle Assign to Driver List " items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Vehicle Assign to Driver List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/assignDriver");
              }}
            >
              <IconPlus width={20} />
            </Button>
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "20px;",
              marginTop: "20px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder=" Search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("driver_name")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Driver Name
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "driver_name" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort("vehicle_no")}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle Number
                      {/* Add arrow icon based on sorting order and column */}
                      {sortColumn === "vehicle_no" &&
                        (sortOrder === "asc" ? " ▲" : " ▼")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedAssignedDriver
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((man, index) => (
                    <TableRow key={man.id}>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography style={{ fontSize: "14px" }} variant="h6">
                          {index + 1}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography style={{ fontSize: "14px" }} variant="h6">
                          {man.driver_name}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Typography style={{ fontSize: "14px" }} variant="h6">
                          {man.vehicle_no}
                        </Typography>
                      </TableCell>

                      <TableCell style={{ textAlign: "center" }}>
                        {/* <Link to={`/updateassignDriver/${man.id}`}>
                          <ModeEditOutlinedIcon
                            style={{
                              color: "blue",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                          />
                        </Link> */}

                        <DeleteOutlinedIcon
                          style={{
                            color: "red",
                            fontSize: "18px",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => deleteAssignDriver(man.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedAssignedDriver.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default AssignVehicle2Driver;
